export const tweenSequence = {
  startFreeSpinButtonAppears: {
    type: 'move',
    durationIn: 1.5,
    easeIn: 'power2.out',
  },
}
